import { render } from "./inputGroupAddons.vue?vue&type=template&id=6374035e&scoped=true"
import script from "./inputGroupAddons.vue?vue&type=script&lang=js"
export * from "./inputGroupAddons.vue?vue&type=script&lang=js"

import "./inputGroupAddons.vue?vue&type=style&index=0&id=6374035e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1199873226/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6374035e"]])

export default __exports__